import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { Menu, X, Phone } from "lucide-react";
import { scrollToId } from "@/api";

const OFFERS = [
  "Early-bird 2026 — flat ₹5,000 off per couple on all international departures",
  "Free visa assistance with every booking this month",
  "Call +91 93192 04006 — your travel designer is one call away",
];

const LINKS = [
  { label: "Destinations", id: "destinations" },
  { label: "Packages", id: "packages" },
  { label: "Why T&T", id: "why-us" },
  { label: "Contact", id: "contact" },
];

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="nav-brand-logo">
    <img src="/logo-mark.jpg" alt="T&T Travels logo" className="h-11 w-auto rounded-lg" />
    {!compact && (
      <span className="leading-none">
        <span className="block font-serif text-xl font-bold text-slate-50 tracking-wide">T&amp;T <span className="gold-text">Travels</span></span>
        <span className="block font-mono text-[9px] uppercase tracking-[0.25em] text-slate-400 mt-1">Tripsandtrick Travel Pvt. Ltd.</span>
      </span>
    )}
  </span>
);

export default function Navbar({ onEnquire }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      scrollToId(id);
    }
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-onyx-900/80 border-b border-white/10" data-testid="main-navbar">
      <div className="bg-gold text-onyx-900 py-1.5" data-testid="announcement-bar">
        <Marquee speed={22} gradient={false} pauseOnHover>
          {OFFERS.map((o) => (
            <span key={o} className="flex items-center">
              <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] px-10">{o}</span>
              <span className="text-onyx-900/50 text-[9px]">◆</span>
            </span>
          ))}
        </Marquee>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.id}`}
              className="text-sm text-slate-300 hover:text-gold transition-colors tracking-wide">
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-4">
          <a href="tel:+919319204006" data-testid="nav-call-link" className="flex items-center gap-2 text-sm text-slate-300 hover:text-gold transition-colors">
            <Phone size={15} /> +91 93192 04006
          </a>
          <button onClick={onEnquire} data-testid="nav-enquire-btn"
            className="rounded-full bg-gold px-6 py-2.5 text-sm font-semibold text-onyx-900 hover:bg-gold-light transition-colors">
            Enquire Now
          </button>
        </div>
        <button className="md:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-onyx-900/95 backdrop-blur-xl px-6 py-6 space-y-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="block w-full text-left text-slate-200 py-1">{l.label}</button>
          ))}
          <button onClick={() => { setOpen(false); onEnquire(); }} data-testid="nav-mobile-enquire-btn"
            className="w-full rounded-full bg-gold px-6 py-3 text-sm font-semibold text-onyx-900">
            Enquire Now
          </button>
        </div>
      )}
    </header>
  );
}
